var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 1024.0 1024.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l1024.0 0l0 1024.0l-1024.0 0l0 -1024.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l1024.0 0l0 1024.0l-1024.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m0 0l1024.0 0l0 1024.0l-1024.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m80.0 512.0l0 0c0 -238.587 193.413 -432.0 432.0 -432.0l0 0c114.57355 0 224.4544 45.514153 305.47015 126.52988c81.015686 81.01572 126.52985 190.8966 126.52985 305.47012l0 0c0 238.58704 -193.41296 432.0 -432.0 432.0l0 0c-238.587 0 -432.0 -193.41296 -432.0 -432.0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m89.6063 512.0l0 0c0 -233.28159 189.11212 -422.3937 422.3937 -422.3937l0 0c112.02576 0 219.46326 44.502068 298.67743 123.716255c79.21423 79.21419 123.71625 186.65166 123.71625 298.67743l0 0c0 233.28162 -189.11206 422.39368 -422.39368 422.39368l0 0c-233.28159 0 -422.3937 -189.11206 -422.3937 -422.39368z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m364.6235 1063.6755l-248.4567 -927.29126l927.2913 248.4567z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m176.0 512.0l0 0c0 -185.56769 150.43231 -336.0 336.0 -336.0l0 0c89.11273 0 174.57568 35.399902 237.58789 98.41211c63.012207 63.012238 98.41211 148.47516 98.41211 237.58789l0 0c0 185.56769 -150.43231 336.0 -336.0 336.0l0 0c-185.56769 0 -336.0 -150.43231 -336.0 -336.0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m185.6063 512.0l0 0c0 -180.26227 146.13144 -326.3937 326.3937 -326.3937l0 0c86.565 0 169.58453 34.387817 230.79523 95.59851c61.210693 61.210693 95.59845 144.2302 95.59845 230.7952l0 0c0 180.26227 -146.13141 326.39368 -326.39368 326.39368l0 0c-180.26227 0 -326.3937 -146.13141 -326.3937 -326.39368z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m344.0 512.0l0 0c0 -185.56769 75.216156 -336.0 168.0 -336.0l0 0c44.556396 0 87.28784 35.399902 118.793945 98.41211c31.506104 63.012238 49.206055 148.47516 49.206055 237.58789l0 0c0 185.56769 -75.21619 336.0 -168.0 336.0l0 0c-92.783844 0 -168.0 -150.43231 -168.0 -336.0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m353.60703 512.0l0 0c0 -180.26227 70.91528 -326.3937 158.3937 -326.3937l0 0c42.008606 0 82.29669 34.387817 112.00122 95.59851c29.70459 61.210693 46.392456 144.2302 46.392456 230.7952l0 0c0 180.26227 -70.91528 326.39368 -158.39368 326.39368l0 0c-87.478424 0 -158.3937 -146.13141 -158.3937 -326.39368z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m507.19684 176.0l9.606323 0l0 662.3937l-9.606323 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m843.19684 502.3937l0 9.606293l-662.3937 0l0 -9.606293z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m799.71655 338.31497l0 9.606293l-572.378 0l0 -9.606293z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m799.71655 666.4724l0 9.606323l-575.3386 0l0 -9.606323z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSquare);
export default __webpack_public_path__ + "static/media/profile_square.8caa362565609e285c8cbcf3776cd6bf.svg";
export { ForwardRef as ReactComponent };